<template>
  <div class="StandardPlan">
    <table>
      <thead>
        <tr>
          <th class="table-title">保养条目</th>
          <th>3000公里/每月</th>
          <th>10000公里/6月</th>
          <th>10000公里/1年</th>
          <th>20000公里/1年</th>
          <th>30000公里/2年</th>
          <th>每60000公里更换</th>
          <th>日常检查</th>
          <th>发现异常时检查</th>
          <th>仅损坏时更换</th>
          <!-- <th>各车型保养间隔不同</th> -->
          <th>每次更换机油时</th>
          <th>每5000公里/6个月更换，或根据机油寿命监测系统提示更换</th>
          <th>内置油滤无需更换，外置油滤更换周期30000公里/2年</th>
          <th>视情况添加，使用期限5年240000公里</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>底盘和车身底板螺栓和螺母的紧固</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>读取高压系统模块故障码</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换乘客厢空气滤清器滤芯</td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换电动系统冷却系统冷却液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换电子驱动单元冷却液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换发动机传动皮带</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换发动机机油和机油滤清器</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换发动机空气滤清器滤芯</td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换发动机冷却液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
        </tr>
        <tr>
          <td>更换高压电池冷却液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换火花塞</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换燃油管路</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换燃油滤清器</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
        </tr>
        <tr>
          <td>更换手动变速器油液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换正时皮带及张紧轮</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换制动液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>更换自动变速器油液</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查安全保护装置系统部件</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查车辆是否对高压系统进行改装</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            检查车轮定位<van-icon
              name="question"
              @click="() => handleShowTipDialog('必要时对轮胎进行换位和平衡')"
            />
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查挡风玻璃清洗液液位</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查发动机机油油位</td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查发动机冷却系统软管和连接</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查发动机冷却液液位</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查方向盘</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池安装紧固件扭矩</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池低压线束/接插件</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池高压线束/接插件</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池及其他高压系统冷却管路</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池及其他高压系统冷却液壶液位</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池手动断开杆（MSD）</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压电池下部底盘托架</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查高压系统绝缘电阻</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查刮水器刮片</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查节气门</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查轮胎状况和充气压力</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查门窗和密封条</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查门铰链和限位器，并适当补充油脂润滑</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查排气系统部件</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查其他高压线束/接插件</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查前后悬架和转向系统</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查驱动轴护套</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查燃油管路和连接</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查蒸发排放碳罐和蒸汽管路</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            检查支撑气压支柱
            <van-icon
              name="question"
              @click="
                () =>
                  handleShowTipDialog(
                    '气弹簧如有磨损、裂纹或其它形式的损坏，需要及时更换；打开发动机舱盖/ 举升门到全开位置，如果发动机舱盖/ 举升门不能保持开启状态，需要更换气弹簧；气弹簧少量漏油为正常现象，无需更换'
                  )
              "
            />
          </td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查制动衬片和制动盘</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查制动器管路和连接</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查制动液液位</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>检查驻车制动器</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            目视检查发动机传动皮带
            <van-icon
              name="question"
              @click="
                () =>
                  handleShowTipDialog(
                    '检查皮带磨损，开裂，损伤情况；有必要须更换新皮带。'
                  )
              "
            />
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td>●</td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>润滑锁闩</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>润滑锁芯</td>
          <td></td>
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            添加燃油清洁添加剂
            <van-icon
              name="question"
              @click="
                () =>
                  handleShowTipDialog(
                    '对于使用直喷发动机的车辆，至少在每次更换机油时或每行驶15000 公里（以先到者为准），向油箱中添加一瓶燃油添加剂。 在此间隔内可视发动机工作状况相应添加，但无须频繁添加。'
                  )
              "
            />
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td></td> -->
          <td>●</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Dialog, Icon } from 'vant'

export default {
  name: 'StandardPlan',
  components: {
    [Icon.name]: Icon
  },
  methods: {
    handleShowTipDialog(message) {
      Dialog({ message })
    }
  }
}
</script>

<style scoped lang="less">
    .StandardPlan {
        width: calc(100% - 20px);
        height: calc(100vh - 50px);
        margin: 10px auto;
        box-sizing: border-box;
        overflow-x: auto;
    }

    /deep/ .van-icon {
        color: #b6862d;
        margin-left: 5px;
    }

    table {
        width: 100%;
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
        border-width: 0px;
        border-style: hidden;
        border-top: 1px solid #e3e3e3;

        th,
        td {
            padding: 10px 5px;
            border-right: 1px solid #e3e3e3;
            border-bottom: 1px solid #e3e3e3;
            line-height: 1.5;
        }

        th,
        td {
            word-break: break-all;
        }

        th {
            font-size: 12px;
            color: #666;
            background-color: #eee;
        }

        td {
            box-sizing: border-box;
            font-size: 12px;
            color: #7b7b7b;
            line-height: 1.5;
            text-align: center;
        }

        tbody tr:nth-child(even) {
            background-color: #f7f7f7;
        }

        th,
        td {
            width: 100px;
            &:first-child {
                width: 100px;
                border: 1px solid #e3e3e3;
                position: sticky;
                left: 0;
                z-index: 1;
            }
            &:nth-child(7) {
                width: 110px;
            }
            &:nth-child(8) {
                width: 60px;
            }
            &:nth-child(13),
            &:nth-child(14),
            &:nth-child(15) {
                width: 160px;
            }
        }

        thead th {
            position: sticky;
            top: 0;
            z-index: 1;
        }

        thead th.table-title {
            z-index: 2 !important;
        }

        th:first-child {
            color: #fff;
            border-color: #b6862d;
            background-color: #b6862d;
        }

        td:first-child {
            background-color: #fff;
        }
    }
</style>
